import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import FilterRadioButton from '../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../components/FilterRadioButtonsContainer';
import MyModal from '../../../../components/Modal';
import { ActionModalContainer } from '../styles';
import FormGroup from '../../../../components/FormGroup';
import OpacityAnimation from '../../../../components/OpacityAnimation';

interface InactivateModalInterface {
  passengerName: string;
  isReactivateDateSet: boolean;
  setIsReactivateDateSet: Dispatch<SetStateAction<boolean>>;
  inactivateModalShow: boolean;
  setInactivateModalShow: Dispatch<SetStateAction<boolean>>;
  reactivateDate: string;
  handleReactivateDateChange: (date: ChangeEvent<HTMLInputElement>) => void;
  setRehabilitateDate: Dispatch<SetStateAction<string>>;
  handleInactivatePassenger: () => void;
}

export default function InactivateModal({
  passengerName,
  isReactivateDateSet,
  setIsReactivateDateSet,
  inactivateModalShow,
  setInactivateModalShow,
  reactivateDate,
  handleReactivateDateChange,
  setRehabilitateDate,
  handleInactivatePassenger,
}: InactivateModalInterface) {
  return (
    <MyModal
      show={inactivateModalShow}
      title={`Inativar passageiro ${passengerName}`}
      modalBody={(
        <ActionModalContainer>
          <FilterRadioButtonsContainer>
            <FilterRadioButton
              selected={!isReactivateDateSet}
              onClick={() => setIsReactivateDateSet(false)}
            >
              Inativar sem data de reativação indefinida
            </FilterRadioButton>
            <FilterRadioButton
              selected={isReactivateDateSet}
              onClick={() => setIsReactivateDateSet(true)}
            >
              Inativar com data de de reativação programada
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
          {isReactivateDateSet && (
            <OpacityAnimation delay={0.1}>
              <FormGroup>
                <label htmlFor="dayDisable">Selecione a data</label>
                <input type="date" value={reactivateDate} onChange={handleReactivateDateChange} />
              </FormGroup>
            </OpacityAnimation>
          )}
        </ActionModalContainer>
      )}
      closeButtonLabel="Fechar"
      actionButtonLabel="Confirmar"
      onClose={() => {
        setRehabilitateDate('');
        setIsReactivateDateSet(false);
        setInactivateModalShow(false);
      }}
      onAction={() => handleInactivatePassenger()}
      isActionButtonDisabled={isReactivateDateSet ? (!reactivateDate) : false}
      type="deleteAction"
      size='lg'
    />
  );
}
